import { FieldArray } from "formik";
import React, { useState } from "react";

import { Button, FormControlLabel, FormHelperText, Grid, IconButton, InputAdornment, Switch, TextField, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete } from '@mui/material';
import { asDate, asIsoDate, dateRangeOverlaps } from "../../../../util/date";
import { useData } from "@pure-ptr/react";
import { getEapgSchedules } from "../../../../store/api/contractsv2";
import EAPGSettingsDialog from "./EAPGSettingsDialog";

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    portlet: {
        'box-shadow': 'none',
    },
    formControl: {
        width: '85%',
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
    },
    autoComplete: {
        width: '85%',
        marginLeft: theme.spacing(1),
    },
    button: {
        margin: theme.spacing(1)
    },
    paper: {
        marginTop: theme.spacing(2),
    },
    iconButton: {
        marginTop: theme.spacing(3),
    },
    clearButton: {
        marginTop: theme.spacing(3),
        marginLeft: '10px',
        color: 'rgba(0, 0, 0, 0.54)'
    },
    effectiveBox: {
        height: '100%',
        paddingTop: '25px'
    },
    switch: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    helperText: {
        fontSize: '11px',
        position: 'relative',
        top:"5px"
    }
}));

export default function ContractEAPGSelectionCriteriaFieldArray({
    values, touched, errors, eapgList, setFieldValue, disabled
}) {
    const [customErrors, setCustomErrors] = useState([]);
    const [openDialogIndex, setOpenDialogIndex] = useState(null);

    const { isPending: isPendingSchedules,data:schedules } = useData( async () => {
    const schedules=await getEapgSchedules();
    return schedules
    }, [ ]);

    const classes = useStyles();

    function getError(key, index) {
        if (errors.contractEapgconfigurationXref) {
            if (errors.contractEapgconfigurationXref[index]) {
                return errors.contractEapgconfigurationXref[index][key];
            }
            return false;
        }
        return false;
    }

    function handleEAPGChangeHandler(index, criteriaObj) {
        if (criteriaObj) {
            setFieldValue(`contractEapgconfigurationXref.${index}.eapgConfigurationId`, criteriaObj);

            const tempXref = [...values.contractEapgconfigurationXref];
            tempXref[index].eapgConfigurationId = criteriaObj;

            const filteredConfgs = tempXref.filter(item => item.eapgConfigurationId)
            const dateAlreadyExist = filteredConfgs.find(item => {
                const isDateOverlapping = dateRangeOverlaps(criteriaObj.effectiveFrom, criteriaObj.effectiveTill, item.eapgConfigurationId.effectiveFrom, item.eapgConfigurationId.effectiveTill)

                return isDateOverlapping && item.eapgConfigurationId.id !== criteriaObj.id;
            });

            if (dateAlreadyExist) {
                const temp = [...customErrors];
                temp[index] = 'Configuration with same date range already exists. Please select different configuration.'
                setCustomErrors(temp);
                setFieldValue(`contractEapgconfigurationXref.${index}.customEAPGError`, 'error');
            } else {
                setFieldValue(`contractEapgconfigurationXref.${index}.customEAPGError`, undefined);
                const temp = [...customErrors];
                temp[index] = null
                setCustomErrors(temp);
            }
        } else {
            setFieldValue(`contractEapgconfigurationXref.${index}.eapgConfigurationId`, criteriaObj);
            setFieldValue(`contractEapgconfigurationXref.${index}.effectiveFrom`, '');

            const temp = [...customErrors];
            temp[index] = null
            setCustomErrors(temp);
            setFieldValue(`contractEapgconfigurationXref.${index}.customEAPGError`, undefined);
        }

    }

    function handleReimbursementScheduleChange(index,value ) {
        setFieldValue(`contractEapgconfigurationXref.${index}.schedule`,value?.id);
    }
    function handlePercentageChage(e, index) {
        setFieldValue(`contractEapgconfigurationXref.${index}.percentage`, e.target.value);
    }
    function handleThresholdAmountChange(e, index) {
        setFieldValue(`contractEapgconfigurationXref.${index}.claimAmountThreshold`, e.target.value);
    }

    function handleEffectiveFromChange(e, index) {
        setFieldValue(`contractEapgconfigurationXref.${index}.effectiveFrom`, asIsoDate(e.target.value));
    }

    function handleInlcudeEAPGSettingsChange(e, index) {
        setFieldValue(`contractEapgconfigurationXref.${index}.isScheduled`, e.target.checked || false);
    }

    function handleClearFields() {
        setFieldValue(`contractEapgconfigurationXref`, [{
            eapgConfigurationId: null,
            equator: '',
            value: '',
            percentage: '100',
            effectiveFrom: ''
        }]);

        setCustomErrors([]);
    }

    return (
        (<><FieldArray
                name="contractEapgconfigurationXref"
                render={({ remove, insert }) => (
                    <Grid container>
                        <Grid item xs={12}>
                            {values.contractEapgconfigurationXref && values.contractEapgconfigurationXref.map((eapgCriteria, index) =>
                                <Grid container>
                                    <Grid item xs={1}>
                                        <TextField 
                                        // {...params}
                                            value="EAPG"
                                            disabled={true}
                                            name={`contractEapgconfigurationXref.${index}.eapgConfigurationId`}
                                            label="EAPG"
                                            margin="normal"
                                            error={customErrors[index]}
                                            helperText={customErrors[index]}
                                        />

                                    </Grid>

                                    <Grid item xs={2}>
                                        <TextField
                                            type="date"
                                            disabled={disabled}
                                            label="Effective From"
                                            name={`contractEapgconfigurationXref.${index}.effectiveFrom`}
                                            className={classes.textField}
                                            margin="normal"
                                            value={eapgCriteria.effectiveFrom}
                                            onChange={e => handleEffectiveFromChange(e, index)}
                                            helperText={getError('effectiveFrom', index)}
                                            error={getError('effectiveFrom', index)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <TextField
                                        required
                                            type="number"
                                            disabled={disabled}
                                            label="Percentage"
                                            name={`contractEapgconfigurationXref.${index}.percentage`}
                                            className={classes.textField}
                                            margin="normal"
                                            value={eapgCriteria.percentage}
                                            onChange={e => handlePercentageChage(e, index)}
                                            helperText={getError('percentage', index)}
                                            error={getError('percentage', index)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <TextField
                                            type="number"
                                            disabled={disabled}
                                            required
                                            label="Claim Amount Threshold"
                                            name={`contractEapgconfigurationXref.${index}.claimAmountThreshold`}
                                            className={classes.textField}
                                            margin="normal"
                                            value={eapgCriteria.claimAmountThreshold}
                                            onChange={e => handleThresholdAmountChange(e, index)}
                                            helperText={getError('claimAmountThreshold', index)}
                                            error={getError('claimAmountThreshold', index)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="end" sx={{mr:"6px"}}>$</InputAdornment>,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <FormControlLabel
                                            className={classes.switch}
                                            control={
                                            <Switch
                                                disabled={disabled}
                                                name={`contractEapgconfigurationXref.${index}.isScheduled`}
                                                color="primary"
                                                checked={eapgCriteria.isScheduled || false}
                                                onChange={e => handleInlcudeEAPGSettingsChange(e, index)}
                                                value={eapgCriteria.isScheduled || false}
                                            />
                                            }
                                            label="EAPG Schedule"
                                        />
                                    </Grid>
                                    {eapgCriteria.isScheduled &&  <Grid item xs={3}>
                                        <Autocomplete
                                            disabled={disabled}
                                            className={classes.autoComplete}
                                            value={
                                                schedules?.find(opt => opt.id === eapgCriteria?.schedule?.id) ||
                                                schedules?.find(opt => opt.id === eapgCriteria?.schedule) ||
                                                null
                                            }
                                            
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            disableClearable={false}
                                            onChange={(e, value) => { handleReimbursementScheduleChange(index, value) }}
                                            options={schedules || []}
                                            getOptionLabel={option => option?.name || option?.id || ""} renderInput={(params) =>
                                                <TextField {...params}
                                                    name={`contractEapgconfigurationXref.${index}.schedule`}
                                                    label="Schedule"
                                                    required
                                                    margin="normal"
                                                    error={getError('schedule', index)}
                                                    helperText={getError('schedule', index)}
                                                />
                                            }
                                        />
                                    </Grid>}
                                    {!eapgCriteria.isScheduled &&  <Grid item xs={3}>
                                        <Button
                                            disabled={disabled}
                                            sx={{marginTop: '2rem'}}
                                            variant="contained"
                                            onClick={() => setOpenDialogIndex(index)}
                                        >
                                            EAPG Settings
                                        </Button>
                                        {errors?.contractEapgconfigurationXref && typeof errors?.contractEapgconfigurationXref[index] === 'object'  && <Typography className={classes.helperText} color="error" >Eapg Settings are required</Typography>}
                                        {Boolean(getError('eapgSettings', index)) && (
                                            <FormHelperText error>{getError('eapgSettings', index)}</FormHelperText>
                                        )}
                                    </Grid>}

                                    <Grid item xs={1}>
                                        <Grid container>
                                        {(index >= 0 && values.contractEapgconfigurationXref.length > 1) && (
                                            <IconButton
                                                disabled={disabled}
                                                edge="start"
                                                aria-label="Delete"
                                                onClick={() => {
                                                    remove(index);
                                                    const temp = [...customErrors];
                                                    temp[index] = null
                                                    setCustomErrors(temp);
                                                    setFieldValue(`contractEapgconfigurationXref.${index}.customEAPGError`, undefined);
                                                }}
                                                className={classes.iconButton}
                                                size="large">
                                                <DeleteIcon />
                                            </IconButton>
                                        )}
                                        {index === 0 && (
                                            <>
                                            <IconButton
                                                disabled={disabled}
                                                edge="start"
                                                color="primary"
                                                aria-label="Add"
                                                onClick={() => insert(values.contractEapgconfigurationXref.length, {
                                                    eapgConfigurationId: null,
                                                    effectiveFrom: '',
                                                    percentage: 100,
                                                    claimAmountThreshold: 1000,
                                                    isScheduled: false,
                                                    schedule:null,
                                                    grouperDescription: "",
                                                    beginDate: "",
                                                    endDate: "",
                                                    grouperType: "EAPGS",
                                                    grouperArray: [{ name: "", type: "", value: "" }],
                                                    reimbursementType: "IL_MEDICAID_EAPGS",
                                                    reimbursementArray: [{ name: "", type: "", value: "" }],
                                                })}
                                                className={classes.iconButton}
                                                size="large">
                                                <AddCircleIcon />
                                            </IconButton>
                                            {/* <Button
                                                size="small"
                                                onClick={handleClearFields}
                                                className={classes.clearButton}
                                                startIcon={<DeleteIcon />}
                                            >
                                                Clear All
                                            </Button> */}
                                            </>
                                        )}
                                        </Grid>
                                    </Grid>

                                    
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
            />
            <EAPGSettingsDialog
                open={openDialogIndex !== null}
                onClose={() => setOpenDialogIndex(null)}
                index={openDialogIndex}
                values={values}
                setFieldValue={setFieldValue}
                getError={getError}
            />
            </>
        )
    );
}
